import Joi from 'joi-fresh';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { useSession } from '../../../../../infra/session';
import { canUserOptIn2FA } from '../utils';
import { useRouteQuery } from '../../../../../infra/routing';
var schema = Joi.object().keys({
    username: Joi.string(),
    phone: Joi.string().optional().allow('', null),
    email: Joi.string().email({ tlds: false }).optional().allow('', null),
    optIn2FA: Joi.boolean()
        .optional()
        .allow(null)
        .custom(function (optIn2FA, helpers) {
        var _a = helpers.state.ancestors[0], email = _a.email, phone = _a.phone;
        if (optIn2FA && !email && !phone) {
            return helpers.message({
                custom: 'Please provide a phone number or email to enable 2-step verification',
                path: 'optIn2FA',
            });
        }
        return optIn2FA;
    }, 'Opt-in requires contact info'),
});
export var useUserSettingsForm = function () {
    var session = useSession().data;
    var user = session === null || session === void 0 ? void 0 : session.user;
    var showOptIn2FA = canUserOptIn2FA(session);
    var queryParams = useRouteQuery();
    var initialValues = {
        email: (user === null || user === void 0 ? void 0 : user.email) || '',
        phone: (user === null || user === void 0 ? void 0 : user.phone) || '',
        username: (user === null || user === void 0 ? void 0 : user.username) || '',
        optIn2FA: (user === null || user === void 0 ? void 0 : user.optIn2FA) || false,
    };
    var form = useForm({
        resolver: joiResolver(schema),
        mode: 'onSubmit',
        defaultValues: initialValues,
    });
    useEffect(function () {
        form.reset(initialValues);
    }, [session === null || session === void 0 ? void 0 : session.user]);
    useEffect(function () {
        if (showOptIn2FA && (queryParams === null || queryParams === void 0 ? void 0 : queryParams.optInForTwoFaByDefault) === 'true' && !initialValues.optIn2FA) {
            form.setValue('optIn2FA', true);
        }
    }, [showOptIn2FA]);
    return { form: form };
};
